export const blockIconsHardwareKeyboardReturn = (
	<span className='material-symbols-outlined'>keyboard_return</span>
);
